import React, { useState } from 'react';
import api from '../api';

export default function BlogEditor() {
  const [title, setTitle] = useState('');
  const [summary, setSummary] = useState('');
  const [content, setContent] = useState('');
  const [message, setMessage] = useState('');

  async function submit(e) {
    e.preventDefault();
    setMessage('');
    try {
      await api.post('/api/blogs/', { title, summary, content });
      setMessage('Submitted for approval.');
      setTitle('');
      setSummary('');
      setContent('');
    } catch (err) {
      const detail = err.response?.data?.detail;
      setMessage(typeof detail === 'string' ? detail : 'Submit failed.');
    }
  }

  return (
    <div className="container mx-auto p-4">
      <h2 className="text-2xl mb-4">Write a Blog</h2>
      <form onSubmit={submit}>
        <input
          value={title}
          onChange={(e) => setTitle(e.target.value)}
          placeholder="Title"
          className="border p-2 w-full mb-2"
          required
        />
        <input
          value={summary}
          onChange={(e) => setSummary(e.target.value)}
          placeholder="Summary (optional)"
          className="border p-2 w-full mb-2"
        />
        <textarea
          value={content}
          onChange={(e) => setContent(e.target.value)}
          placeholder="Content"
          className="border p-2 w-full mb-2 h-48"
          required
        />
        <button type="submit" className="bg-blue-600 text-white p-2">Submit</button>
      </form>
      {message && <p className="mt-4">{message}</p>}
    </div>
  );
}
